import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { serverLine } from "../../../controllers/network/serverLine";
import EmployeeCard from "../../pages/loggedIn/employees/EmployeeCard";
import LoadingSection from "../../helperComponents/LoadingSection";
import CustomLabel from "../CustomLabel";
import CustomButton from "../../helperComponents/CustomButton";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: var(--surface);
  border-radius: 10px;
  /* margin: 25px; */
  padding: 15px;
`;
const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const FetchAbsenceReplacement = ({
  userID,
  date,
  mode = "absence",
  vacantSlot,
  callback,
}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [userID, date, mode, vacantSlot?.siteID, vacantSlot?.shift, vacantSlot?.slotIndex]);

  if (loading) return <LoadingSection />;

  return (
    <Container>
      <CustomLabel>remplaçant actuel</CustomLabel>

      <List>
        {data && data.length > 0 ? (
          <>
            {data.map((doc, idx) => (
              <EmployeeCard key={idx} data={doc} />
            ))}
            {mode === "rest" || mode === "vacant" ? (
              <CustomButton onClick={removeReplacement}>
                Désélectionner l'agent
              </CustomButton>
            ) : null}
          </>
        ) : (
          <p>Aucun remplaçant trouvé</p>
        )}
      </List>
    </Container>
  );

  async function fetchData() {
    try {
      setLoading(true);
      const path =
        mode === "rest"
          ? `/rest-replacement/?userID=${userID}&date=${date}`
          : mode === "vacant"
          ? `/vacant-slot-assignment/?date=${date}&siteID=${vacantSlot?.siteID}&shift=${vacantSlot?.shift}&slotIndex=${vacantSlot?.slotIndex}`
          : `/absence-replacement/?userID=${userID}&date=${date}`;
      const response = await serverLine.get(path);

      setData(response.profiles);
    } catch (err) {
      console.error("Error fetching absence replacement:", err);
    } finally {
      setLoading(false);
    }
  }

  async function removeReplacement() {
    try {
      setLoading(true);

      const path =
        mode === "vacant"
          ? `/vacant-slot-assignment/?date=${date}&siteID=${vacantSlot?.siteID}&shift=${vacantSlot?.shift}&slotIndex=${vacantSlot?.slotIndex}`
          : `/rest-replacement/?userID=${userID}&date=${date}`;

      await serverLine.delete(path);

      await fetchData();
      if (typeof callback === "function") callback();
    } catch (err) {
      console.error("Error removing replacement:", err);
      setLoading(false);
    }
  }
};

export default FetchAbsenceReplacement;
